import { render } from "./VideoListEditModal.vue?vue&type=template&id=05666aab&scoped=true"
import script from "./VideoListEditModal.vue?vue&type=script&lang=js"
export * from "./VideoListEditModal.vue?vue&type=script&lang=js"

import "./VideoListEditModal.vue?vue&type=style&index=0&id=05666aab&scoped=true&lang=less"
import "./VideoListEditModal.vue?vue&type=style&index=1&id=05666aab&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05666aab"]])

export default __exports__